export default "__VITE_ASSET__C$b3IuRy__"